import axios from "axios";
import { SERVER_URL } from "../config";


export const fetchGetYear = async () => {
  try {
    const response = await axios.get(
      `${SERVER_URL}/get_years.php`
    );

    return response.data; // ✅ must return array of years
  } catch (error) {
    console.error("Error fetching year list:", error);
    throw error;
  }
};
